import React, { useState } from "react";
import Cameralist from "./Cameralist";
import { TbPolygon } from "react-icons/tb";

export default function Step2SelectCameras({
  formData,
  setFormData,
  drawMode,
  setDrawMode,
}) {
  const [showCamera, setShowCamera] = useState(false);
  const [lineSide, setLineSide] = useState("top");

  // Default: Full screen
  const [areaType, setAreaType] = useState(formData.area_type || "full_screen");

  const handleLineSideChange = (value) => {
    setLineSide(value);
    setFormData((prev) => ({
      ...prev,
      restricted_side: value,
      polygon_data: prev.polygon_data.map((poly) => ({
        ...poly,
        restricted_area_type: value,
      })),
    }));
  };

  const handleAreaTypeChange = (value) => {
    setAreaType(value);
    setFormData((prev) => ({
      ...prev,
      area_type: value,
    }));
    if (value === "full_screen") {
      setDrawMode("");
    }
  };

  return (
    <>
      <h4>Cameras</h4>
      <p className="formTitle mt-3 mb-4">
        Select camera / camera group for this event from the drawer on the
        right.
      </p>

      <div className="d-flex align-items-center gap-4">
        <button className="mainBlue3 px-5" onClick={() => setShowCamera(true)}>
          Camera Select
        </button>
        <p className="cameraSelect m-0">
          {formData.camera_ids.length} Camera selected
        </p>
      </div>

      {/* Step 1: Area type selection */}
      {formData.camera_ids.length > 0 && (
        <div className="mt-4">
          <p className="mb-2">Select Area Type:</p>
          <div className="d-flex gap-4">
            <label>
              <input
                type="radio"
                value="full_screen"
                checked={areaType === "full_screen"}
                onChange={(e) => handleAreaTypeChange(e.target.value)}
              />{" "}
              Full Screen
            </label>
            <label>
              <input
                type="radio"
                value="specific_area"
                checked={areaType === "specific_area"}
                onChange={(e) => handleAreaTypeChange(e.target.value)}
              />{" "}
              Specific Area
            </label>
          </div>
        </div>
      )}

      {/* Step 2: Drawing tools only if specific_area */}
      {formData.camera_ids.length > 0 && areaType === "specific_area" && (
        <div className="mt-4">
          <p className="mb-2">Choose Drawing Mode:</p>
          <div className="d-flex gap-3">
            <button
              className={`btn ${
                drawMode === "line" ? "btn-primary" : "btn-outline-primary"
              }`}
              onClick={() => setDrawMode("line")}
            >
              📏 Draw Line
            </button>
            <button
              className={`btn ${
                drawMode === "polygon" ? "btn-primary" : "btn-outline-primary"
              }`}
              onClick={() => setDrawMode("polygon")}
            >
              🔺 Draw Polygon
            </button>
          </div>
        </div>
      )}

      {/* Step 3: Line side selection */}
      {drawMode === "line" && areaType === "specific_area" && (
        <div className="mt-3">
          <label className="form-label">Select Side:</label>
          <select
            className="form-select"
            value={lineSide}
            onChange={(e) => handleLineSideChange(e.target.value)}
          >
            <option value="top">Top</option>
            <option value="bottom">Bottom</option>
          </select>
        </div>
      )}

      {drawMode === "polygon" && areaType === "specific_area" && (
        <div className="mt-3">
          <label className="form-label">Select Side:</label>
          <select
            className="form-select"
            value={lineSide}
            onChange={(e) => handleLineSideChange(e.target.value)}
          >
            <option value="inside">inside</option>
            <option value="outside">outside</option>
          </select>
        </div>
      )}

      {/* Step 4: Drawing instructions */}
      {drawMode && areaType === "specific_area" && (
        <div className="startDrawing mt-4">
          <div className="d-flex gap-2">
            <TbPolygon size={26} /> Click anywhere on the zoomed camera to start
            drawing a <strong>{drawMode}</strong>.
          </div>
        </div>
      )}

      {/* Camera list modal */}
      {showCamera && (
        <Cameralist
          setShowCamera={setShowCamera}
          formData={formData}
          setFormData={setFormData}
        />
      )}
    </>
  );
}
